import * as React from 'react';

const FlagChunkySvg = (props: React.SVGProps<SVGSVGElement>) => (
    <svg viewBox="0 0 24 24" {...props}>
        <path d="M6.2 19H5v1h3.5v-1H7.3v-5.8h5.9V5h-7zM16.7 10.2l2.1-4h-4.5v8.1H19z" />
    </svg>
);

FlagChunkySvg.displayName = 'FlagChunkySvg';
export default FlagChunkySvg;
